import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { IconSvgComponent } from '@roomex/rx-components';

@Component({
  selector: 'rx-applications-offer-banner',
  templateUrl: './offer-banner.component.html',
  styleUrls: ['./offer-banner.component.scss'],
  standalone: true,
  imports: [CommonModule, NgbTooltipModule, IconSvgComponent],
})
export class OfferBannerComponent {
  @Input() icon!: string;
  @Input() text?: string;
  @Input() tooltipText?: string;
  @Input() color: 'green' | 'red' | 'red-light' | 'orange' | 'green-dark' = 'orange';
  @Input() iconColor: string = 'white';

  get theme() {
    return `offer-banner--${this.color}`;
  }
}
